export default [
  {
    path: '/Home',
    name: 'home',
  },
];
